import { Injectable } from "@angular/core";
import { Observable } from "rxjs/Observable";
import { IAPIResponse, WeGoConfig } from "../../shared/config";
import { AuthService } from "../../shared/models/auth.service";
import { Http } from "@angular/http";

@Injectable()
export class ReportDamageService {
  constructor(private authService: AuthService, private http: Http) {}

  public UpdateDamageReport(formData: FormData): Observable<IAPIResponse> {
    return Observable.create((observer: any) => {
      let url: string = WeGoConfig.API_REPORT_DAMAGE;
      let xhr: XMLHttpRequest = new XMLHttpRequest();
      let header = this.authService.GetHeaderForFile();
      xhr.onreadystatechange = () => {
        if (xhr.readyState === 4) {
          if (xhr.status === 200) {
            console.log(xhr.response);
            observer.next(JSON.parse(xhr.response));
            observer.complete();
          } else {
            observer.error(xhr.status);
            //this.authService.HandleAPIError(xhr.response.status)
          }
        }
      };

      xhr.open("POST", url, true);
      for (let i = 0; i < header.length; i++) {
        xhr.setRequestHeader(header[i]["name"], header[i]["value"]);
      }
      xhr.send(formData);
    });
  }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/app/booking/models/report-damage.service.ts